/**
 * How finely a shared composer control draws. Inside the prompt box
 * (ChatComposerFrame provides `fine`): 14px icons at a 1.75 stroke, regular
 * weight and a 7px send button. Outside it, as in the review composer, the
 * same controls keep the `standard` finish.
 *
 * @module components/chat/composerFinish
 */
import { createContext, useContext } from "react";

export type ComposerFinish = "standard" | "fine";

export const ComposerFinishContext = createContext<ComposerFinish>("standard");

export const useComposerFinish = (): ComposerFinish => useContext(ComposerFinishContext);
